import { DOCUMENT_ENDPOINTS } from '@/config/api';
import { httpClient } from '@/lib/http-client';
import type { DocumentResource, DocumentResponse } from '@/types/document';

export class DocumentsApi {
  static getDocument(
    resource: DocumentResource,
    resourceId: number,
  ): Promise<DocumentResponse> {
    return httpClient.get<DocumentResponse>(
      DOCUMENT_ENDPOINTS.CUSTOMER_DOCUMENT(resource, resourceId),
    );
  }
}

export function openDocument(response: DocumentResponse): void {
  if (response.url) {
    window.open(response.url, '_blank', 'noopener,noreferrer');
    return;
  }

  if (response.content) {
    const binary = atob(response.content);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank', 'noopener,noreferrer');
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    return;
  }

  throw new Error('Документ не найден');
}
